import { IonInput, IonItem, IonLabel, IonTextarea } from '@ionic/react';

export function validCorrection(reason: string, copies: string): boolean {
  const n = Number(copies);
  return reason.trim().length > 0 && reason.trim().length <= 450
    && Number.isInteger(n) && n >= 0 && n <= 500;
}

export function LotCorrectionFields({ reason, copies, onReason, onCopies }: {
  reason: string; copies: string; onReason: (value: string) => void; onCopies: (value: string) => void;
}) {
  return <>
    <IonItem><IonLabel position="stacked">Motivo della rettifica (autocontrollo)</IonLabel>
      <IonTextarea value={reason} maxlength={450} autoGrow onIonInput={(e) => onReason(e.detail.value ?? '')} />
    </IonItem>
    <IonItem><IonLabel position="stacked">Etichette da ristampare (0 = nessuna)</IonLabel>
      <IonInput type="number" min={0} max={500} step="1" value={copies} onIonInput={(e) => onCopies(e.detail.value ?? '')} />
    </IonItem>
    <p style={{ fontSize: '0.85em' }}>La rettifica resta nello storico. La ristampa usa l’etichetta collegata al lotto e non modifica la giacenza.</p>
  </>;
}
